export type IRouteFunction = (idHolding?: string, idPos?: string) => string;
interface IRouteElement extends Record<string, IRouteFunction | IRouteElement> {}

export function extractPaths(routes: IRouteElement): string[] {
    return Object.values(routes).reduce((all: string[], v: IRouteElement | IRouteFunction) => {
        return typeof v === 'function' ? [...all, v()] : all.concat(extractPaths(v));
    }, []);
}
